// extracted by mini-css-extract-plugin
export default {"p":"styles_p__GlipU","h":"styles_h__hl-M3"};